import { render, staticRenderFns } from "./SystemCommunicationsEmailHeader.vue?vue&type=template&id=5486c06c&scoped=true"
import script from "./SystemCommunicationsEmailHeader.vue?vue&type=script&lang=js"
export * from "./SystemCommunicationsEmailHeader.vue?vue&type=script&lang=js"
import style0 from "./SystemCommunicationsEmailHeader.vue?vue&type=style&index=0&id=5486c06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486c06c",
  null
  
)

export default component.exports